import { render, staticRenderFns } from "./ClicTableColumnDetail.vue?vue&type=template&id=514f1011&"
import script from "./ClicTableColumnDetail.vue?vue&type=script&lang=js&"
export * from "./ClicTableColumnDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports